export enum StatisticsReportType {
    performance,
    recipients,
    composition,
}
